import { Box } from "@mui/material";
import BootstrapDialog from "./BootstrapDialog"
import BootstrapDialogTitle from "./BootstrapDialogTitle"

const CustomDialog = ({ children, title, show, handleShow }) => {
  function handleClose(event, reason) {
    if (reason && reason === "backdropClick") {
      return
    } else {
      handleShow(false);
    }
  };

  return <BootstrapDialog
    open={show}
    onClose={handleClose}
    scroll="body"
    aria-labelledby="customized-dialog-title"
    fullWidth
    maxWidth="sm"
  >
    <BootstrapDialogTitle onClose={handleClose} id="customized-dialog-title">
      {title}
    </BootstrapDialogTitle>
    <Box
      id={"dialog-container"}
      sx={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}
    >
      {children}
    </Box>
  </BootstrapDialog>
}

export default CustomDialog